import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen w-full bg-[var(--midnight)] overflow-hidden" data-id="element-197">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--dusk-purple)]/20 via-transparent to-transparent pointer-events-none" data-id="element-198" />

      <div className="relative max-w-7xl mx-auto px-6 py-20 md:py-32" data-id="element-199">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-200">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-201">
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl text-[var(--cream)] leading-tight" data-id="element-202">
              <span className="italic" data-id="element-203">Para El Que Llora</span>
              <br data-id="element-204" />
              <span className="italic" data-id="element-205">Cuando Nadie Lo Ve</span>
            </h1>

            <p className="text-xl md:text-2xl text-[var(--cream)]/80 leading-relaxed max-w-xl" data-id="element-206">
              El proceso que está devolviendo la paz a personas que ya no creían
              en ellos mismos.
            </p>

            {/* Testimonial micro-element */}
            <div className="flex items-center gap-2 text-[var(--warm-gold)]" data-id="element-207">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-208" />)}
              <span className="text-[var(--cream)]/70 ml-2 text-sm" data-id="element-209">
                "Un viaje de descubrimientos que cambia vidas" — Samantha Castro
              </span>
            </div>

            {/* CTA */}
            <motion.button onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="group bg-[var(--warm-gold)] text-[var(--midnight)] px-8 py-4 rounded-full font-semibold text-lg flex items-center gap-2 transition-all shadow-lg hover:shadow-xl" data-id="element-210">
              Quiero Empezar Mi Vuelo
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-211" />
            </motion.button>
          </motion.div>

          {/* Right: Book mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/h9LmkdYvVbaehFpvmXgpLJ/heylloyd-image-1780447888541.png" alt="El Vuelo del Renacer - Libro en tablet" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-213" />
          </motion.div>
        </div>
      </div>
    </section>;
}